import { get, post, put, del, patch } from 'aws-amplify/api';
import logging from '../config/logging';

// Helper functions to wrap the new API client
export const API = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get: async (apiName: string, path: string, init?: any) => {
        logging.info(`Init: ${init}`);
        const restOperation = get({
            apiName,
            path,
            options: init
        });
        const { body } = await restOperation.response;
        const json = await body.json();
        return json as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    post: async (apiName: string, path: string, init?: any) => {
        const restOperation = post({
            apiName,
            path,
            options: {
                body: init?.body,
                headers: init?.headers
            }
        });
        const { body } = await restOperation.response;
        const json = await body.json();
        return json as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    put: async (apiName: string, path: string, init?: any) => {
        const restOperation = put({
            apiName,
            path,
            options: {
                body: init?.body,
                headers: init?.headers
            }
        });
        const { body } = await restOperation.response;
        const json = await body.json();
        return json as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    patch: async (apiName: string, path: string, init?: any) => {
        const restOperation = patch({
            apiName,
            path,
            options: {
                body: init?.body,
                headers: init?.headers
            }
        });
        const { body } = await restOperation.response;
        const json = await body.json();
        return json as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    del: async (apiName: string, path: string, init?: any) => {
        const restOperation = del({
            apiName,
            path,
            options: init
        });
        const { body } = await restOperation.response;
        const json = await body.json();
        return json as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    }
};
